export function getImageItemProps(item) {
  return { file: item }
}
